import React from 'react';
import LoadingContainer from '../../../components/Common/LoadingContainer';

const LoadingState = () => {
    return (
        <LoadingContainer 
            message="Loading survey..." 
            subMessage="Please wait while we prepare your survey"
            fullPage={true}
        />
    );
};

export default LoadingState;